<div class="actions">
  <button nz-button nzType="primary" (click)="add()" >{{resolveKey("AddMenu") | translate}}</button>
  <!-- <button nz-button (click)="export()">{{resolveKey("Export") | translate}}</button>
  <nz-upload (nzChange)="fileChange($event)" [nzAccept]="'.xls,.xlsx'" [nzShowUploadList]="false" [nzLimit]="1" [nzAction]="uploadUrl">
    <button nz-button >{{resolveKey("Import") | translate}}</button>
  </nz-upload> -->
</div>

<nz-table #table mm-table [nzData]="expandItems$ | async" [nzFrontPagination]="false" [nzSize]="'small'">
  <thead>
    <tr>
      <th [nzWidth]="'300px'">{{resolveKey('Name') | translate}}</th>
      <th>{{resolveKey('Url') | translate}}</th>
      <th [nzWidth]="'60px'">{{resolveKey('Icon') | translate}}</th>
      <th [nzWidth]="'150px'">{{resolveKey('Move') | translate}}</th>
      <th [nzWidth]="'200px'">
        {{resolveKey('Action') | translate}}
        <!-- <button nz-button [nzType]="'link'" (click)="add()">
          <i style="color: white;" nz-icon [nzType]="'plus'"></i>
      </button> -->
      </th>
    </tr>

  </thead>
  <tbody>
    <ng-container *ngFor="let item of table.data">
      <tr *ngIf="(item.parant && item.parant.expand) || !item.parant">
        <!-- <td [nzIndentSize]="item.level! * 20" [nzShowExpand]="item.type=='Folder'" [nzExpand]="item.expand"
          (nzExpandChange)="onExpandChange(item.id,$event)"> -->
        <td [nzIndentSize]="item.level! * 20">
          <ng-container *ngIf="item.type=='Folder' || item.type=='Dynamic'">
            <button *ngIf="item.expand" nz-button [nzType]="'link'" (click)="onExpandChange(item.id,false)">
              <i nz-icon [nzType]="'folder-open'"></i>
            </button>
            <button *ngIf="!item.expand" nz-button [nzType]="'link'" (click)="onExpandChange(item.id,true)">
              <i nz-icon [nzType]="'folder'"></i>
            </button>


          </ng-container>
          <ng-container *ngIf="item.type=='Link' || item.type=='ExternalLink'">
            <button nz-button [nzType]="'link'" (click)="onExpandChange(item.id,true)">
              <i nz-icon [nzType]="'link'"></i>
            </button>
          </ng-container>
          {{item.name | localize}}

        </td>
        <td>
          {{item.url}}

        </td>
        <td>
          <!--<button nz-button [nzType]="'link'" class="icon-btn-bg">
          <i nz-icon [nzType]="item.icon"></i>
        </button>-->
          <div class="icon-btn-bg" *ngIf="item.icon">
            <i nz-icon [nzType]="item.icon"></i>
          </div>
        </td>
        <td>
          <button nz-button [nzType]="'link'" (click)="move(item.id,'left')" *ngIf="item.parant!==undefined">
            <i nz-icon [nzType]="'arrow-left'" nzTheme="outline"></i>
          </button>
          <button nz-button [nzType]="'link'" (click)="move(item.id,'up')" *ngIf="!item.isFirst">
            <i nz-icon [nzType]="'arrow-up'" nzTheme="outline"></i>
          </button>
          <button nz-button [nzType]="'link'" (click)="move(item.id,'down')" *ngIf="!item.isLast">
            <i nz-icon [nzType]="'arrow-down'" nzTheme="outline"></i>
          </button>
          <button nz-button [nzType]="'link'" (click)="move(item.id,'right')" *ngIf="item.hasFolderAbove">
            <i nz-icon [nzType]="'arrow-right'" nzTheme="outline"></i>
          </button>
        </td>
        <td>

          <button *ngIf="item.type=='Folder'" nz-button [nzType]="'link'" (click)="add(item.id)">
            <i nz-icon [nzType]="'plus'"></i>
          </button>
          <button nz-button [nzType]="'link'" (click)="edit(item.id)">
            <i nz-icon [nzType]="'edit'"></i>
          </button>
          <mm-delete-icon (confirm)="delete(item.id)"></mm-delete-icon>
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>